var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "w-100" }, [
    _c(
      "ul",
      { staticClass: "mobile-list pl-4 mt-3" },
      [
        _vm._l(_vm.collections.slice(0, 3), function(collection) {
          return _c("li", { key: collection.code }, [
            _c("a", {
              staticClass: "text-reset text-decoration-none",
              attrs: {
                href: _vm.$helpers.getCollectionOverviewUrl(collection.name)
              },
              domProps: {
                innerHTML: _vm._s(
                  _vm.$helpers.matchText(collection.name, _vm.searchTerm)
                )
              }
            })
          ])
        }),
        _vm._v(" "),
        _vm._l(_vm.pages.slice(0, 3), function(page) {
          return _c("li", { key: page.code }, [
            _c("a", {
              staticClass: "text-reset text-decoration-none",
              attrs: { href: page.url },
              domProps: {
                innerHTML: _vm._s(
                  _vm.$helpers.matchText(page.title, _vm.searchTerm)
                )
              }
            })
          ])
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("ul", { staticClass: "mobile-list-menu pl-4 mt-3" }, [
      _c("li", [
        _c(
          "a",
          {
            staticClass: "text-reset text-decoration-none",
            attrs: { href: "/search?searchTerm=" + _vm.searchTerm }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$resourceString["site.search.collections.result.header"]
                ) +
                "\n      "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            staticClass: "text-reset text-decoration-none",
            attrs: {
              href: "/search?searchTerm=" + _vm.searchTerm + "&tab=styles"
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$resourceString["site.search.styles.result.header"]
                ) +
                "\n      "
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c(
          "a",
          {
            staticClass: "text-reset text-decoration-none",
            attrs: {
              href: "/search?searchTerm=" + _vm.searchTerm + "&tab=page-content"
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$resourceString["site.search.result.page.content"]) +
                "\n      "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mt-5 pl-4 pb-4" }, [
      _c(
        "a",
        {
          staticClass: "see-all-link",
          attrs: { href: "/search?searchTerm=" + _vm.searchTerm }
        },
        [
          _c("span", { staticClass: "pr-1" }, [
            _vm._v(_vm._s(_vm.$resourceString["site.search.result.see.all"]))
          ]),
          _vm._v(" "),
          _c("span", {
            staticClass: "png-icon png-icon-icons-glyph--k-arrow-right-sm"
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }